import {
  errorsProps,
  ValidationErrorTypes,
} from '../components/SummaryErrors/SummaryErrors';

export const mergeValidationErrors = (errors: errorsProps[]): errorsProps[] => {
  const backendFieldNames = new Set(
    errors
      .filter((e) => e.type === ValidationErrorTypes.Backend)
      .flatMap((e) => [
        e.fieldName,
        ...(e.affectedFields?.map((f) => f.fieldName) ?? []),
      ])
  );

  return errors.filter(
    (error) =>
      error.type === ValidationErrorTypes.Backend ||
      !backendFieldNames.has(error.fieldName)
  );
};
